import { assign } from "es6-object-assign";
import Backbone from "backbone";
// Just pass on Backbone events
var EventStore = /** @class */ (function () {
    function EventStore() {
    }
    return EventStore;
}());
;
;
assign(EventStore.prototype, Backbone.Events);
export default EventStore;
